<script>
import { QScrollArea } from 'quasar'

import { mergeData } from 'vue-functional-data-merge'
export default {
  functional: true,
  render (createElement, context) {
    const { data, children } = context
    return createElement(QScrollArea, mergeData({
      props: {
        thumbStyle: {
          right: '4px',
          borderRadius: '5px',
          backgroundColor: ['var(--primary)', '#027be3'],
          width: '5px',
          opacity: 0.75
        },
        barStyle: {
          right: '2px',
          borderRadius: '9px',
          backgroundColor: ['var(--primary)', '#027be3'],
          width: '9px',
          opacity: 0.2
        }
      },
      staticClass: 'i-scroll-area'
    }, data), children)
  }
}
</script>
